module.exports = __webpack_public_path__ + "static/media/AB_K17_1.cb8b2743.jpg";